import {
	appClipsCapability,
	AppClipsCapability,
	BaseURL,
	launchApp,
	launchAppClip,
	ShouldAppClipsLaunchViaAppleLinks,
	ShouldLaunchApp,
	ShouldLaunchAppClip,
} from './Core'
import{ AppType, MarketingPlatform, Metrics, Page, TriggerPoint } from './Metrics'
import { ActionBar } from './Shared/ActionBar'


//
// region constants
//

declare const _marketingPlatform:MarketingPlatform
declare const DEBUG_IncludePreviewData:boolean|undefined

let DEBUG_includePreviewData:boolean = (typeof(DEBUG_IncludePreviewData) !== 'undefined') && DEBUG_IncludePreviewData

//


$( async function() {
	// init
	const actionBar = new ActionBar( Page.SocialFeedPage )
	actionBar.show()
	fetchPosts()
	
	// metrics
	Metrics.logSocialFeedPageViewed( _marketingPlatform )

	// app launch
	// TODO(DRY): generalize across pages
	await Metrics.logAppClipsCapability()
	// console.debug( `ShouldLaunchApp: ${ShouldLaunchApp}` )
	// console.debug( `ShouldLaunchAppClip: ${ShouldLaunchAppClip}` )
	if( ShouldLaunchAppClip ){
		if( ShouldAppClipsLaunchViaAppleLinks ){
			/*NOTE: ignore async*/await launchAppClip()
		} else { /*do nothing – handled via <meta> param*/ }
	} else if( ShouldLaunchApp ){
		/*NOTE: ignore async*/await launchApp()
	}
	
	
	// TODO(DRY): move into social posts component
	function fetchPosts( /*isHistoryPop:boolean*/ ){
		const previewPart:string = (DEBUG_includePreviewData) ? '?preview=true' : ''
		const url:string = `${BaseURL}/part/social-posts${previewPart}`
		fetch( url, { method: 'GET' })
			.then( (result:Response) => result.text())
			.then( (htmlBlock:string) => {
				$('#social-posts').html( htmlBlock )
				// if( !isHistoryPop )
				// 	history.pushState({ 'region': region }, null, historyURLParams )
			})
			.catch( (errorMessage:string) => {
				let snackbar:HTMLElement = document.getElementById( 'snackbar' )
				snackbar.classList.add( 'show' )
				setTimeout( () => {
					snackbar.classList.remove('show' )
				}, 3000 )
			})
			.finally(() => {
				// deactivate async UI
				$('#posts-loader').addClass( 'd-none' )
				$('#posts-container').show()

				initPosts()
			})
	}


	// TODO(DRY): move into social posts component
	function initPosts() {
		$('.post-item').on( 'click', async (e) => {
			let postItem:JQuery<HTMLElement> = $(e.currentTarget)

			let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
			if( appType == AppType.Transient ) // NOTE: behaviour is only to launch for transient apps – otherwise continue to destination page
				await Metrics.logNAV_launchApp( appType, Page.SocialFeedPage, TriggerPoint.ListItem )

			// navigate
			let href:string = postItem.attr( 'data-href' )
			// console.debug( `HREF: ${href}` )
			await Metrics.flush() // NOTE: ensure metrics are pushed before navigating away
			window.location.href = href
		})
	}
	
})
